import * as React from 'react';
import * as utils from '../../common/hex-converter';
import styles from './slider-readonly.scss';

/* Shared display layer between slider
    in readOnly mode, and placeholder for non-edit modes */
export interface SliderReadonlyProps {
  valueItem: any;
  textNoData?: string; // "not selected"
}

export const SliderReadonly = (props: SliderReadonlyProps) => {
  if (!props.valueItem) {
    return(null);
  }

  let colorToDisplayFromBackend = {};

  if (props.valueItem.backgroundColor && props.valueItem.description.length) {
    const convertedColor = utils.toHex(props.valueItem.backgroundColor);
    colorToDisplayFromBackend = {
      background: `${convertedColor} `,
      display: 'block'
    };
  }
  return(
    <div className={styles.sliderReadOnly}>
      <div className = {styles.colorDot }
            style = { colorToDisplayFromBackend }
              />
      { !!props.valueItem ? props.valueItem.description : <p className="no-content">{props.textNoData}</p> }
    </div>
  );
};
